import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export const OAuthDisclosure: React.FC = () => {
    return (
        <div className="mt-4 text-center">
            <p className="text-xs text-mystic-400 leading-tight">
                <span className="flex justify-center items-center gap-1 mb-1 text-mystic-300">
                    <ShieldCheck size={12} className="text-gold-500" />
                    <span>פרטיות ומידע</span>
                </span>
                בהתחברותך, את/ה מסכים/ה <Link to="/terms-of-use" target="_blank" className="text-gold-400 hover:underline">לתנאי השימוש</Link> ו<Link to="/privacy-policy" target="_blank" className="text-gold-400 hover:underline">מדיניות הפרטיות</Link>.
                <br />
                אנו משתמשים בפרטי חשבונך אך ורק לצורך זיהוי, שמירת המפות האישיות וניהול שיחות המחקר ב-AI בצורה מאובטחת.
            </p>
        </div>
    );
};
